import { Guid, Nillable } from '@web/utils';
import { FormControl, FormGroup } from '@angular/forms';
import { QuantityUnit } from '@web/shared/module/measurement';
import { WarehouseProductType } from '../enums/warehouse-product-type';

export type WarehouseProductControls = {
  brandId: FormControl<Nillable<Guid>>;
  durabilityInformation: FormControl<Nillable<string>>;
  name: FormControl<Nillable<string>>;
  ownerId: FormControl<Nillable<Guid>>;
  promotion: FormControl<Nillable<boolean>>;
  quantity: FormControl<Nillable<number>>;
  sku: FormControl<Nillable<string>>;
  type: FormControl<Nillable<WarehouseProductType>>;
  unit: FormControl<QuantityUnit>;
  localizationId: FormControl<Nillable<Guid>>;
  measure: FormControl<Nillable<string>>;
};

export class WarehouseProductFormData {
  public static readonly MinQuantity = 0;
  public static readonly MaxSkuLength = 30;
  public static readonly MaxNameLength = 255;
  public static readonly MaxDurabilityInformationLength = 255;

  public constructor(
    private data: {
      brandId?: Nillable<Guid>;
      durabilityInformation?: Nillable<string>;
      localizationId?: Nillable<Guid>;
      measure: Nillable<string>;
      name?: Nillable<string>;
      ownerId?: Nillable<Guid>;
      promotion: Nillable<boolean>;
      quantity?: Nillable<number>;
      sku?: Nillable<string>;
      type?: Nillable<WarehouseProductType>;
      unit: QuantityUnit;
    },
  ) {}

  public get ownerId(): Nillable<Guid> {
    return this.data.ownerId;
  }

  public get type(): Nillable<WarehouseProductType> {
    return this.data.type;
  }

  public get sku(): Nillable<string> {
    return this.data.sku;
  }

  public get name(): Nillable<string> {
    return this.data.name;
  }

  public get unit(): QuantityUnit {
    return this.data.unit;
  }

  public get quantity(): Nillable<number> {
    return this.data.quantity;
  }

  public get durabilityInformation(): Nillable<string> {
    return this.data.durabilityInformation;
  }

  public get brandId(): Nillable<string> {
    return this.data.brandId;
  }

  public get localizationId(): Nillable<string> {
    return this.data.localizationId;
  }

  public get promotion(): Nillable<boolean> {
    return this.data.promotion;
  }

  public get measure(): Nillable<string> {
    return this.data.measure;
  }
}

/* prettier-ignore */
export type WarehouseProductControlsToDisable = keyof Pick<WarehouseProductControls, 'quantity'>;

/* prettier-ignore */
export type WarehouseProductFormGroup = FormGroup<WarehouseProductControls>;
